// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"ace66ec3","95":"b11b3976","195":"4908b3a3","238":"1f0a2fbe","453":"aa8ce82c"}[chunkId] + ".chunk.js";
};